import { useDarkMode } from "@/hooks/useDarkMode";
import React from "react";
import { IoCheckmarkCircleOutline } from "react-icons/io5";
import { CiWarning } from "react-icons/ci";
import { PiInfo } from "react-icons/pi";

interface CustomToastProps {
  message: string;
  type?: "error" | "success" | "normal";
  onClose?: () => void;
}

const CustomToast: React.FC<CustomToastProps> = ({
  message,
  type = "normal",
  onClose,
}) => {
  let icon;
  let backgroundColor;

  const isDark = useDarkMode();

  switch (type) {
    case "success":
      backgroundColor = "#10B981"; // Green color for success
      icon = (
        <IoCheckmarkCircleOutline
          size={24}
          color={isDark ? "#6EE7B7" : backgroundColor}
          aria-hidden="true"
        />
      );
      break;
    case "error":
      backgroundColor = "#F87171"; // Red color for error
      icon = <CiWarning size={24} color={backgroundColor} aria-hidden="true" />;
      break;
    default:
      backgroundColor = "#352FC3"; // Blue color for normal
      icon = <PiInfo size={24} color={isDark ? "#A39FE8" : backgroundColor} aria-hidden="true" />;
      if (isDark) {
        backgroundColor = "#A39FE8";
      }
      break;
  }
  return (
    <div
      role="status"
      aria-live={type === "error" ? "assertive" : "polite"}
      aria-atomic="true"
      style={{
        borderTopColor: backgroundColor,
      }}
      className="bg-bg-brand-secondary-default rounded-[10px] border-t-[8px] flex flex-col"
    >
      <div className="flex-1 py-[12px] flex flex-row">
        <div className="px-[12px]">{icon}</div>
        <div className="flex-1 justify-center pr-[16px]">
          <div className="label-m-medium text-fg-neutral-strong">{message}</div>
        </div>
      </div>
    </div>
  );
};

export default CustomToast;
